import { APP_ROUTES } from "../navigation/appRoutes";

export default function LandingFooter() {
  return (
    <footer className="landing-footer" aria-label="Links legais do orion33">
      <div className="landing-footer__brand">orion33</div>

      <div className="landing-footer__contact">
        <span aria-label="Copyright orion33">&copy; 2026 orion33</span>
        <span className="landing-footer__email">contato@orion33.com.br</span>
      </div>

      <nav className="landing-footer__links" aria-label="Links legais">
        <a href={APP_ROUTES.PRIVACY}>Privacidade</a>
        <a href={APP_ROUTES.TERMS}>Termos</a>
      </nav>
    </footer>
  );
}
